import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { type SearchResponse } from '@pkg/types';
import { type ApiResult } from '@pkg/types/api';

import { callSearchEmoji } from '@app/client/resources/emojis.ts';
export function useSearchEmoji() {
    const queryClient = useQueryClient();
    return useCallback(
        async (emojiID: string) => {
            return await queryClient.fetchQuery({
                queryKey: ['emoji-search-single', emojiID],
                queryFn: ({ signal }) =>
                    callSearchEmoji({ settings: { signal }, query: { emoji_id: emojiID } }) as Promise<
                        ApiResult<SearchResponse>
                    >,
                staleTime: Infinity,
            });
        },
        [queryClient],
    );
}
